import { useEffect } from "react";
import type { SignedIn } from "../store.ts";
import { store } from "../store.ts";
import { AuthPage } from "./Login.tsx";

/** After signing in: which business this device shows, when the account has several. */
export function Choose({ signedIn, onDone }: { signedIn: SignedIn; onDone: () => void }) {
  const only = signedIn.workspaces.length === 1 ? signedIn.workspaces[0]! : null;
  const choose = async (id: string) => {
    await store.choose(signedIn, id);
    // A link to confirm the address (S28) waits for the sign-in: it stays.
    if (!location.hash.startsWith("#/email/")) location.hash = "#/speisekarten";
    onDone();
  };
  useEffect(() => {
    if (only) void choose(only.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <AuthPage>
      <div className="card">
        <h2>Hallo {signedIn.user.displayName}!</h2>
        {signedIn.workspaces.length === 0 ? (
          <p>Dein Konto gehört noch zu keinem Betrieb.</p>
        ) : only ? (
          <p className="muted">Lädt …</p>
        ) : (
          <>
            <p>Mit welchem Betrieb möchtest du auf diesem Gerät arbeiten?</p>
            {signedIn.workspaces.map((w) => (
              <button key={w.id} className="wide" onClick={() => void choose(w.id)}>
                {w.name}
              </button>
            ))}
          </>
        )}
      </div>
    </AuthPage>
  );
}
